import { ShieldCheck, FileCheck2, Lock, Landmark } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "ГОСТ Р 34.10-2012" },
  { icon: FileCheck2, label: "63-ФЗ «Об электронной подписи»" },
  { icon: Lock, label: "Шифрование AES-256" },
  { icon: Landmark, label: "Интеграция с 1С:Предприятие и ФНС России" },
];

export function LandingTrustBar() {
  return (
    <section className="py-12 border-y border-slate-200 bg-slate-50" data-testid="landing-trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {ITEMS.map((it) => (
          <div key={it.label} className="flex items-center gap-3 justify-center md:justify-start">
            <it.icon className="w-5 h-5 text-[#2563EB] shrink-0" />
            <span className="text-xs sm:text-sm text-slate-600">{it.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
